import { api } from './client';

/** Quem cuida de um processo no escritório (docs/PLANO_COMPARTILHAMENTO_ESCRITORIO.md §19). */
export interface Responsavel {
  tipo: 'USUARIO' | 'EQUIPE';
  valor: string;
}

export interface ResponsaveisDoProcesso {
  processo_id: string;
  dono_id: string;
  /** Sem distribuição gravada: o responsável é o dono do processo. */
  automatico: boolean;
  responsaveis: Responsavel[];
  pode_distribuir: boolean;
}

export interface ItemDaFila {
  processo_id: string;
  numero: string;
  classe: string;
  tribunal: string;
  dono_id: string;
  dono_nome: string | null;
  chegou_em: string;
  sugestao: Responsavel;
  /**
   * REGRA: o destino da regra do escritório que casou. AGUARDANDO_DADOS: a primeira regra que pode
   * valer depende de um dado que o processo ainda não tem (`faltando`); a sugestão é a de antes das
   * regras. MESMO_CLIENTE: quem cuida dos outros processos do cliente. DONO: o da OAB por onde chegou.
   */
  motivo: 'REGRA' | 'AGUARDANDO_DADOS' | 'MESMO_CLIENTE' | 'DONO';
  regra_id?: string | null;
  regra_nome?: string | null;
  /** Campos da regra (CLASSE, ASSUNTO, VALOR…) que o processo ainda não tem. */
  faltando?: string[];
  /** A regra que casou tem critério da IA: o motivo que a IA deu. */
  motivo_ia?: string | null;
}

export interface FilaParaDistribuir {
  itens: ItemDaFila[];
  total: number;
  /** Há regra com critério da IA e os créditos de IA do escritório acabaram: ela não sugere. */
  ia_sem_creditos?: boolean;
}

export interface Distribuidos {
  atribuidos: number;
  /** Os que não estão no escritório (o dono os retirou, ou não é membro). */
  ignorados: number;
}

export type ModoDeAtribuir = 'SUBSTITUIR' | 'ADICIONAR';

export async function fetchResponsaveis(escritorioId: string, processoId: string): Promise<ResponsaveisDoProcesso> {
  const { data } = await api.get<ResponsaveisDoProcesso>(
    `/escritorios/${escritorioId}/processos/${processoId}/responsaveis`,
  );
  return data;
}

export async function atribuirResponsaveis(
  escritorioId: string,
  processoIds: string[],
  responsaveis: Responsavel[],
  modo: ModoDeAtribuir = 'SUBSTITUIR',
): Promise<Distribuidos> {
  const { data } = await api.put<Distribuidos>(`/escritorios/${escritorioId}/responsaveis`, {
    processo_ids: processoIds,
    responsaveis,
    modo,
  });
  return data;
}

export async function fetchFilaParaDistribuir(escritorioId: string): Promise<FilaParaDistribuir> {
  const { data } = await api.get<FilaParaDistribuir>(`/escritorios/${escritorioId}/distribuicao`);
  return data;
}

export async function definirGestor(escritorioId: string, membroId: string, gestor: boolean): Promise<void> {
  await api.put(`/escritorios/${escritorioId}/membros/${membroId}/gestor`, { gestor });
}
